// Email Configuration
export const emailConfig = {
    // Your email address (sender)
    senderEmail: 'your-email@example.com', // CHANGE THIS TO YOUR EMAIL
    senderName: 'AICIS Conference Team',
    
    // Email service configuration (choose one)
    // Option 1: Using EmailJS (free tier available)
    emailjs: {
      serviceId: 'your_service_id',
      templateId: 'your_template_id',
      userId: 'your_user_id',
    },
    
    // Option 2: Using a backend API endpoint
    apiEndpoint: '/api/send-email',
    
    // Default email template
    defaultSubject: 'Regarding Your Speaker Application',
    defaultMessage: `Dear [Speaker Name],
  
  Thank you for your interest in speaking at our conference. We have reviewed your application and would like to discuss further.
  
  Best regards,
  Conference Team`,
  };